import { useEffect, useState } from "react";
import "./works.scss"
import { chatapp } from "../../data";


function Works(props) {
    const [selected, setSelected] = useState("chatapp");
    const [data, setData] = useState([]);
    const [currentSlider, setCurrentSlider] = useState(0)

    useEffect(() => {
        switch (selected) {
            case "chatapp":
                setData(chatapp);
                break;
        }
    }, [selected]);

    const handleClick = (way) => {
        way === "left"
            ? setCurrentSlider(currentSlider > 0 ? currentSlider - 1 : 1)
            : setCurrentSlider(currentSlider < data.length - 1 ? currentSlider + 1 : 0)
    }

    return (
        <div className='works' id="works">
            <h1>ReactJS Portfolio</h1>
            <div className="slider" style={{ transform: `translateX(-${currentSlider * 100}vw)` }}>
                {data.map((d) => (
                    <div className="container">
                        <div className="item">
                            <div className="left">
                                <div className="leftContainer">
                                    <div className="imgContainer">
                                        <img src={d.icon} alt="" />
                                    </div>
                                    <h2>{d.title}</h2>
                                    <p>{d.description}</p>
                                </div>
                            </div>
                            <div className="right">
                                <img src={d.img} alt="" />
                            </div>
                        </div>
                    </div>
                ))
                }
            </div>
            <img src="assets/down arrow.png" className="arrow left" alt="" onClick={() => handleClick("left")} />
            <img src="assets/down arrow.png" className="arrow right" alt="" onClick={() => handleClick()} />
        </div>
    );
}

export default Works;
